import httpUtils from '../../utils/HttpUtils'

class CustomerAddressService {

  //地址列表
  async list() {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/list');
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //保存地址
  async save (customerAddress = {}) {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/save',customerAddress);
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //设置默认地址
  async setDefault (addressId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/set/default',{addressId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //获取默认地址
  async getDefault () {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/get/default');
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //删除地址
  async delete (addressId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/delete',{addressId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //地址详情
  async detail (addressId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/address/detail',{addressId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new CustomerAddressService()
